import React from "react";
import {Breadcrumb, Button, Card, Col, Divider, Form, Input, Modal, Row, Space} from 'antd';
import {PlusOutlined} from '@ant-design/icons';
import Grid from "../../redare/components/grid/Grid";
import BaseComponent from "../../redare/components/BaseComponent";
import {WebPage} from "../../redare_components/webplatform_workbench/utils/WorkbenchDecoratorUtil";
import ApplicationPresenter from "../../.gen/presenter/ApplicationPresenter";
import Window from "../../redare/components/modal/Window";
import ApplicationForm from "../../components/application/ApplicationForm";
import {Link} from "react-router-dom";
import FunPermission from "../../redare_components/webplatform_workbench/components/permission/FunPermission";
import ApplicationCommonForm from "../../components/application/ApplicationCommonForm";
import EllipsisTooltip from "../../components/common/EllipsisTooltip";
import ModalNoAnt from "../../components/common/ModalNoAnt";
import {ifTrue} from "../../redare/utils/Utils";

export default @WebPage({
    classify: '应用设置',
    id: 'com.redare.webmanager.pages.application.ApplicationPage',
    name: '应用设置',
    des: '应用设置',
    webPath: '/application/list',
    webFunIds: [
        'editAppInfo',
        'delAppInfo',
        'addApplication',
    ],
    props: {
        application: '应用设置'
    }
})
class ApplicationPage extends BaseComponent {
    constructor(props) {
        super(props);
        this.applicationPresenter = new ApplicationPresenter(this);
        this._user = window._workbench._user;
        if (this._user !== undefined) {
            this._isRoot = this._user.root;
        } else {
            this._isRoot = false;
        }
        this.state = {
            visible: false,
            text: "",
            title: "",
            applicationModalTitle: '新增应用'
        };
    }

    //加载列表
    _loadApplicationPage(body, curPage) {
        if (body === undefined) {
            body = {};
        }
        if (curPage === undefined) {
            curPage = 1;
        }
        if (this.grid) {
            this.grid.showLoadingIndicator();
        }
        this.applicationPresenter.findApplicationPage(body, {curPage, pageSize: 10}, (result) => {

            if (this.grid) {
                this.grid.setData(result.data.result, result.data);
                this.grid.closeLoadingIndicator();
            }
        });
    }

    componentDidMount() {
        this._loadApplicationPage();
    }

    //查询
    _search() {
        this.formRef.validateFields()
            .then(values => {
                this.searchValues = values;
                this._loadApplicationPage(this.searchValues, 1);
            });
    }

    //分页
    _onPageChange({curPage}) {
        this._loadApplicationPage(this.searchValues, curPage)
    }

    //新增
    _add = () => {
        this.applicationFormId = undefined;
        this.setState({applicationModalTitle: '新增应用'});
        this.applicationModal.show();
    }
    //编辑
    _edit = id => {
        this.applicationFormId = id;
        this.setState({applicationModalTitle: '编辑应用'});
        this.applicationModal.show();
        this.applicationModal.showAndGetInstance((form)=>{
            form.loadInfo(id);
        });
        // else {
        //     this._winEdit = Window.show(
        //         <ApplicationCommonForm
        //             onCancel={() => {
        //                 this._winEdit.close()
        //             }}
        //             id={id}
        //             onEditSuccess={this._onEditSuccess.bind(this)}
        //         />,
        //         {
        //             title: '编辑应用',
        //             width: '700px'
        //         });
        // }

    }
    _onEditSuccess = () => {
        this._winEdit.close();
        this._search();
    }
    //删除
    _del = id => {
        this.confirm("你确定删除？", () => {
            this.applicationPresenter.deleteApplication({id: id}, {}, (result) => {
                this.toastSuccess("删除成功！");
                this._search();
            });
        })
    }

    //重置
    _reset() {
        this.formRef.resetFields();
        this._search();
    }

    _more(text, title) {
        this.setState({
            visible: true,
            text,
            title
        });
    }

    handleOk = e => {
        this.setState({
            visible: false,
        });
    };

    handleCancel = e => {
        this.setState({
            visible: false,
        });
    };

    render() {
        const rowSelection = {};
        return (
            <div className="ReportPushConfiguration-Page">
                <div className="bg-white bord-bot">
                    <div className="width-all padding02">
                        <Breadcrumb>
                            <Breadcrumb.Item><Link to="/">工作台</Link></Breadcrumb.Item>
                            <Breadcrumb.Item><Link to="/site">系统设置</Link></Breadcrumb.Item>
                            <Breadcrumb.Item>应用设置</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                </div>
                <div className="width-all">
                    <div className="margin024">
                        <Card bordered={false} className="margin24" title="应用设置">
                            <Form className="information-form" ref={(o) => this.formRef = o}>
                                <Row gutter={24} justify="space-between">
                                    <Col span={8}>
                                        <Form.Item label="应用名称" name="key">
                                            <Input placeholder="请输入关键词"/>
                                        </Form.Item>
                                    </Col>
                                    <Col>
                                        <Space size={16}>
                                            <Button type="primary" onClick={() => this._search()}>查询</Button>
                                            <Button onClick={() => this._reset()}>重置</Button>
                                        </Space>
                                    </Col>
                                    <FunPermission funId="addApplication">
                                        <Col span={24} style={{marginBottom: 24}}>
                                            <Button icon={<PlusOutlined/>} type="primary"
                                                    onClick={() => this._add()}>添加应用</Button>
                                        </Col>
                                    </FunPermission>
                                </Row>
                            </Form>
                            <Grid
                                ref={(o) => {
                                    this.grid = o
                                }}
                                _onPageChange={this._onPageChange.bind(this)}
                                size="middle"
                                scroll={{x: 'max-content'}}
                                _initLoading={false}
                                bordered={false}
                                rowSelection={rowSelection}
                                rowKey={(v) => v.id}
                                columns={[
                                    {
                                        title: '应用名称',
                                        dataIndex: 'name',
                                    },
                                    {
                                        title: '系统编码',
                                        dataIndex: 'sysCode'
                                    },
                                    {
                                        title: '访问链接',
                                        dataIndex: 'appAccessUrl'
                                    },
                                    {
                                        title: '分类',
                                        dataIndex: 'classifyName',
                                    },
                                    {
                                        title: '访问code',
                                        dataIndex: 'accessCode',
                                        render: (text) => <EllipsisTooltip>{text}</EllipsisTooltip>
                                    },
                                    {
                                        title: '访问密钥',
                                        dataIndex: 'accessKey'
                                    },
                                    {
                                        title: '排序',
                                        dataIndex: 'sort',
                                    },
                                    {
                                        title: '操作',
                                        fixed: 'right',
                                        width: 100,
                                        render: (text, record, index) => {
                                            return (
                                                <>
                                                    <FunPermission funId="editAppInfo">
                                                        <a onClick={() => this._edit(record.id)}>编辑</a>
                                                    </FunPermission>
                                                    <FunPermission funId="delAppInfo">
                                                        <Divider type="vertical"/>
                                                        <a onClick={() => this._del(record.id)}>删除</a>
                                                    </FunPermission>
                                                </>
                                            )
                                        }
                                    }
                                ]}/>
                        </Card>
                    </div>
                </div>
                <Modal
                    title={this.state.title}
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                >
                    {this.state.text}
                </Modal>

                <ModalNoAnt
                  ref={(o)=>{ this.applicationModal = o }}
                  title={this.state.applicationModalTitle}
                  width='700px'
                  okText={'保存'}
                  okfn={()=>{ this._applicationModalOkFn() }}
                >
                    <ApplicationForm />
                </ModalNoAnt>

            </div>
        )
    }


    async _applicationModalOkFn(){

        let form = this.applicationModal.getInstance();
        let formData = await form.getFormData();
        if( !formData ){
            return ;
        }

        this.applicationModal.openLoading();

        if( ifTrue(this.applicationFormId) ){
            formData.roleIds = undefined;
            formData.orgIds = undefined;
            formData.pcRoleIds = undefined;
            formData.pcOrgIds = undefined;
            formData.id = this.applicationFormId;
            this.applicationPresenter.editApplication(formData,{},(result)=>{
                this.toastSuccess("修改成功!");
                this.applicationModal.closeModal();
                this._search();
            },(f_r)=>{
                this.applicationModal.closeLoading();
            });
        }else {
            this.applicationPresenter.addApplication(formData,{},(result)=>{
                this.toastSuccess("添加成功!");
                this.applicationModal.closeModal();
                this._search();
            },()=>{
                this.applicationModal.closeLoading();
            });
        }
    }
}
